import { useUrlStateV2 } from 'hooks';

export function useFocusedUser() {
  const [{ focusId }, updateUrl] = useUrlStateV2({
    focusId: '',
  });

  return {
    focusId,
    focusUser: (focusId: string | null) => updateUrl({ focusId }),
  };
}
